export default __webpack_public_path__ + "static/marvin-teaser-7cce1b087bd68fcd2598cb18ba677dbc.jpg";